/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Step2_Seaweed_TitleInputs */



/**
* | output |
* | --- |
* | "oneCloud Storage" |
*
* @param {Spaces_Wizard_Step2_Seaweed_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step2_seaweed_title = /** @type {((inputs?: Spaces_Wizard_Step2_Seaweed_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step2_Seaweed_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("oneCloud-Speicher")
	return /** @type {LocalizedString} */ ("oneCloud Storage")
});